import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.for-each";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { searchgame, searchplatform, searchchannel, searchpkg } from "@/api/dataAll/dataAll";
import { getLoginLists } from "@/api/loginConfig/loginList";
import { getadvLocation } from "@/api/dataAll/advLocation";
import { deleLginConfig } from "@/api/loginConfig/deleLogin";
import { restKeyId } from "@/api/loginConfig/restKey";
import addLogin from "./components/addLogin.vue";
export default {
  name: "addLoginConfig",
  components: {
    addLogin: addLogin
  },
  data: function data() {
    return {
      dialog: false,
      num: 1,
      searchgames: [],
      searchplatforms: [],
      searchchannels: [],
      searchpkgs: [],
      tableTitle: [],
      advchannels: [],
      advLocation: [],
      gameId: "",
      searchData: {
        game: "",
        platform: "",
        channel: "",
        pkg: "" // advChannel: "",
        // advLocation: "",

      },
      searchMark: {
        page: 1,
        game: "",
        platform: "",
        channel: "",
        pkg: "" // ad_placement: "",

      },
      total: 0,
      page: 0,
      pagrSize: 10,
      tableData: [],
      tableLtv: [],
      tableDate: "",
      show: false,
      dates: [],
      datas: []
    };
  },
  created: function created() {
    var _this = this;

    searchgame().then(function (res) {
      _this.searchgames = res.data;
      _this.gameId = res.data.id;
    });
  },
  methods: {
    gamechange: function gamechange(id) {
      var _this2 = this;

      if (id != "") {
        searchplatform({
          game_id: id
        }).then(function (res) {
          _this2.searchplatforms = res.data;
          _this2.searchData.platform = "";
          _this2.searchData.channel = "";
          _this2.searchData.pkg = "";
          _this2.searchMark.platform = "";
          _this2.searchMark.channel = "";
          _this2.searchMark.pkg = ""; // this.searchData.advChannel = "";
          // this.searchData.advLocation = "";

          _this2.searchchannels = [];
          _this2.advchannels = [];
          _this2.advLocation = [];
          _this2.searchpkgs = [];

          _this2.searchgames.forEach(function (item) {
            if (item.id == id) {
              _this2.searchMark.game = item.game_mark;
            }
          });
        });
      } else {
        this.searchData.platform = "";
        this.searchData.channel = "";
        this.searchData.pkg = "";
        this.searchMark.pkg = "";
        this.searchMark.platform = "";
        this.searchMark.channel = "";
        this.searchplatforms = [];
        this.searchchannels = [];
        this.searchpkgs = [];
        this.searchMark.game = ""; // this.searchData.advChannel = "";
        // this.searchData.advLocation = "";

        this.advchannels = [];
        this.advLocation = [];
      }
    },
    platformchange: function platformchange(id) {
      var _this3 = this;

      if (id != "") {
        searchchannel({
          platform_id: id
        }).then(function (res) {
          _this3.searchchannels = res.data.channel;
          _this3.advchannels = res.data.adv_platform; //广告平台

          _this3.searchData.channel = "";
          _this3.searchData.pkg = ""; // this.searchData.advChannel = "";
          // this.searchData.advLocation = "";

          _this3.searchMark.channel = "";
          _this3.searchMark.pkg = "";
          _this3.advLocation = [];
          _this3.searchpkgs = [];

          _this3.searchplatforms.forEach(function (item) {
            if (item.id == id) {
              _this3.searchMark.platform = item.platform_mark;
              _this3.searchData.channel = "";
              _this3.searchMark.channel = "";
            }
          });
        });
      } else {
        this.searchData.channel = "";
        this.searchData.pkg = "";
        this.searchMark.channel = "";
        this.searchMark.pkg = "";
        this.searchMark.platform = "";
        this.searchpkgs = [];
        this.searchchannels = []; // this.searchData.advChannel = "";
        // this.searchData.advLocation = "";

        this.advchannels = [];
        this.advLocation = [];
      }
    },
    channelchange: function channelchange(id) {
      var _this4 = this;

      if (id != "") {
        searchpkg({
          channel_id: id
        }).then(function (res) {
          _this4.searchpkgs = res.data;

          _this4.searchchannels.forEach(function (item) {
            if (item.id == id) {
              _this4.searchMark.channel = item.channel_mark;
              _this4.searchData.pkg = "";
              _this4.searchMark.pkg = "";
            }
          });
        });
      } else {
        this.searchData.pkg = "";
        this.searchMark.pkg = "";
        this.searchMark.channel = "";
        this.searchData.channel = "";
        this.searchpkgs = [];
      }
    },
    pkgchange: function pkgchange(id) {
      var _this5 = this;

      if (id != "") {
        this.searchpkgs.forEach(function (item) {
          if (item.id == id) {
            _this5.searchMark.pkg = item.pkg_mark;
          }
        });
      } else {
        this.searchMark.pkg = "";
      }
    },
    advChannelchange: function advChannelchange(id) {
      var _this6 = this;

      if (id != "") {
        getadvLocation({
          advplatform_id: id
        }).then(function (res) {
          _this6.advLocation = res.data;

          _this6.advchannels.forEach(function (item) {
            if (item.id == id) {
              _this6.searchData.advLocation = "";
            }
          });
        });
      } else {
        // this.searchData.advLocation = "";
        // this.searchData.advChannel = "";
        this.advLocation = [];
      }
    },
    advLocationchange: function advLocationchange(id) {
      if (id != "") {
        this.advLocation.forEach(function (item) {
          if (item.id == id) {}
        });
      } else {}
    },
    // 新增弹窗
    dialogShow: function dialogShow() {
      this.dialog = true;
    },
    // 关闭弹窗
    changeShow: function changeShow(val) {
      this.dialog = val;
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.searchMark.page = val;
      this.searchClick();
    },
    searchClick: function searchClick() {
      var _this7 = this;

      this.page = this.searchMark.pag;
      getLoginLists(this.searchMark).then(function (res) {
        if (res.status == 200) {
          var list = ['game', 'platform', 'channel', 'pkg'];
          _this7.tableData = res.data.data.length ? _this7.$utils.dataConversion(res.data.data, list) : [];
          _this7.total = res.data.total || 0;
        }
      });
    },
    // 删除配置
    deleHandle: function deleHandle(id) {
      var _this8 = this;

      this.$confirm("此操作将删除该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                deleLginConfig({
                  id: id
                }).then(function (res) {
                  _this8.searchClick();

                  _this8.$message({
                    type: "success",
                    message: res.message
                  });
                });

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      })));
    },
    // 重置密钥
    handleJoinPeople: function handleJoinPeople(a) {
      var _this9 = this;

      var tid = {
        id: a.id
      };
      this.$alert("<strong>\u5BC6\u94A5ID:<i>".concat(a.secret_key_id, "</i></strong></br><strong>\u5BC6\u94A5key:<i>").concat(a.secret_key_key, "</i></strong>"), {
        dangerouslyUseHTMLString: true,
        confirmButtonText: "重置"
      }).then(function () {
        restKeyId(tid).then(function (res) {
          _this9.$message({
            type: "success",
            message: res.message
          });

          _this9.searchClick();
        }).catch(function () {});
      });
    }
  }
};